import {Component, OnDestroy, OnInit} from '@angular/core';
import {CentreService} from "../../../../services/centre.service";
import {ChildService} from "../../../../components/child/child.service";
import {Observable} from "rxjs";
import {Centre} from "../../../../interfaces/Centres";
import {MatSelectChange} from "@angular/material/select";
import {FullChild} from "../../../../interfaces/FullChild";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {CounselingService} from "../../counseling.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialogRef} from "@angular/material/dialog";
import {TitleCasePipe} from "@angular/common";
import {AuthService} from "../../../../auth.service";
import {LogService} from "../../../../services/log.service";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {GlossaryService} from "../../../../components/glossary/glossary.service";
import {Subject} from "rxjs/internal/Subject";
import {takeUntil} from "rxjs/internal/operators/takeUntil";
import {ListType} from "../../../../components/types/types.component";
import {Task} from "../../../task/models/task.model";
import {TasksService} from "../../../task/tasks.service";
import {NotificationModel, NotificationService} from "../../../../services/notification.service";

@Component({
    selector: 'app-add-individual-session',
    templateUrl: './add-individual-session.component.html',
    styleUrls: ['./add-individual-session.component.scss']
})
export class AddIndividualSessionComponent implements OnInit, OnDestroy {
    centres$: Observable<Centre[]>
    form: FormGroup
    childrenData: FullChild[] = []
    startTime: any
  selectedCentre:any;
  displayCentre = (c: any) => c?.centreName;
    endTime: any
    userName: any
    mGlossaryData: any
    maxDate = new Date()
    destroyed$ = new Subject()
    centreSelect = new FormControl('', [Validators.required]);
    childSelect = new FormControl('', [Validators.required]);
    types = ["Admission Rapport building counselling", "Regular Counselling", "Discharge Counselling", "Follow-up Counselling", "Extended Counselling"]
    _interventionsList$: Observable<String[]>
    _challengesFaced$: Observable<String[]>;
    disableSubmit = false

  childSearchControl = new FormControl('');
  filteredChildData: FullChild[] = [];


  constructor(private centreService: CentreService,
                private childService: ChildService,
                private counsellingService: CounselingService,
                private readonly mLogService: LogService,
                private readonly mGlossary: GlossaryService,
                private _snackBar: MatSnackBar,
                private titlecasePipe: TitleCasePipe,
                private mDatabase: AngularFireDatabase,
                private  readonly mTaskService: TasksService,
                private mGlossaryService: GlossaryService,
                private dialogRef: MatDialogRef<AddIndividualSessionComponent>
    ) {
        this._interventionsList$ = this.mDatabase.list<String>('types/Interventions').valueChanges()
        this._challengesFaced$ = this.mDatabase.list<String>('types/Challenges Faced').valueChanges()

        const userData = JSON.parse(localStorage.getItem('userData')!)
        this.userName = userData?.userName
        this.centres$ = this.centreService.getAllCentres()

        this.form = new FormGroup({
            centreName: new FormControl('', Validators.required),
            centreCode: new FormControl('', Validators.required),
            childName: new FormControl('', Validators.required),
            sessionMode: new FormControl('', Validators.required),
            childCode: new FormControl('', Validators.required),
            gender: new FormControl(''),
            dob: new FormControl(null),
            city: new FormControl(''),
            age: new FormControl(''),
            hospital: new FormControl(''),
            state: new FormControl(''),
            startTime: new FormControl('', Validators.required),
            endTime: new FormControl('', Validators.required),
            participants: new FormControl('', Validators.required),
            date: new FormControl('', Validators.required),
            // description: new FormControl(''),
            challengesFaced: new FormControl('', Validators.required),
            highlight: new FormControl('', Validators.required),
            interventionUsed: new FormControl(''),
            interventions: new FormControl(''),
            interventionUseful: new FormControl(''),
            interventionRemarks: new FormControl(''),
            homeProgram: new FormControl(''),
            homeProgramEffectiveness: new FormControl(''),
            type: new FormControl('', Validators.required),
            remark: new FormControl('',),
            submittedBy: new FormControl(this.userName),
            createdAt: new FormControl(Date.now())

            // type: new FormControl('',Validators.required),

            // childCode:new FormControl('',Validators.required),
        })

    }

    ngOnInit(): void {
        this.mGlossary.fetchCounsellingGlossary().pipe(takeUntil(this.destroyed$)).subscribe(res => {
            this.mGlossaryData = res
        })


      // 🔥 Child search filter logic
      this.childSearchControl.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(search => {
        const value = (search || '').toLowerCase();
        this.filteredChildData = this.childrenData.filter(c =>
          (c.firstName + ' ' + c.lastName).toLowerCase().includes(value)
        );
      });
    }

    ngOnDestroy(): void {
        this.destroyed$.next(null);
        this.destroyed$.complete();
    }

  onChildDropdownOpen() {
    this.childSearchControl.setValue('');
    this.filteredChildData = this.childrenData;
  }


  onCentreSelect(selectedCentre: Centre) {
    if (!selectedCentre) return;

    console.log("Selected Centre:", selectedCentre);

    this.selectedCentre = selectedCentre;

    // Set form values
    this.form.patchValue({
      centreName: selectedCentre.centreName,
      centreCode: selectedCentre.centreCode
    });

    // ---- Load Children (your same logic, untouched) ----
    this.childrenData = [];

    this.childService.fetchAllotedChildListByCenter(selectedCentre.centreCode)
      .subscribe(res => {
        res.forEach(it => this.childrenData.push(it.data() as FullChild));
        this.orderChildrenData();
        this.filteredChildData = [...this.childrenData]; // 👈 ADD THIS
      });

    this.childService
      .getDischargeChildsBeforeThreeDaysFromCurrentDateByCentre(selectedCentre.centreCode)
      .then(res => {
        let discharged = res.docs.map(x => x.data() as FullChild);
        console.log("DISCHARGED CHILDREN IN SELECT:", discharged.length);

        discharged.forEach(d => this.childrenData.push(d));
        this.orderChildrenData();
      });
  }

//
  fetchChildren($event: MatSelectChange) {


        let centre = $event.value as Centre
        // alert(centre)
        this.childrenData = []
        this.childService.fetchAllotedChildListByCenter(centre.centreCode).subscribe(res => {
            res.forEach(it =>
                this.childrenData.push(it.data() as FullChild))

        })
        this.orderChildrenData()
        this.childService.getDischargeChildsBeforeThreeDaysFromCurrentDateByCentre(centre.centreCode).then(res => {
            let c = res.docs.map(x => x.data() as FullChild)
            console.log('DISCHARGED CHILDREN IN SELECT', c.length)
            c.forEach(res => {
                this.childrenData.push(res)
                this.orderChildrenData()

            })
            this.orderChildrenData()

        })
        // this.orderChildrenData()
        this.form.get('centreName')?.setValue(centre.centreName)
        this.form.get('centreCode')?.setValue(centre.centreCode)
    }

get CentreName(){
        return this.form.get('centreName') as FormControl
}

    onChildSelect($event: MatSelectChange) {
        let child = $event.value as FullChild
        this.form.get('childCode')?.setValue(child.childCode)
        this.form.get('gender')?.setValue(child.gender)
        this.form.get('hospital')?.setValue(child.hospital)
        this.form.get('age')?.setValue(calculateFromDob(child.dob.toDate()))
        this.form.get('city')?.setValue(child.city)
        this.form.get('state')?.setValue(child.state)
        this.form.get('dob')?.setValue(child.dob.toDate())
        this.form.get('childName')?.setValue(child.firstName + ' ' + child.lastName)
        function calculateFromDob(dob: Date) {
            const today = new Date();
            const birthDate = dob;

            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();

            // If the birth month has not occurred yet in the current year or it is the same month but the day is not reached
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            return age;
        }

    }

    Submit() {

        if (this.form.valid) {
            this.disableSubmit = true
            this.counsellingService.addIndividualSession(this.form.value).then(() => {
                let task =this.buildTask(this.form.get('childName')?.value, this.form.get('centreCode')?.value)
                try {
                    let config:Partial<NotificationModel>={
                        color:'amber',
                        icon:'book',
                        link:'/home/education/individual',
                        type:'trigger',
                    }
                    this.mTaskService.addAutomatedTask(task,config)

                } catch (e){
                    console.log('Error adding task', e)
                }

                this._snackBar.open('Session Submitted')._dismissAfter(3000)
                let activity = {
                    date: new Date().getTime(),
                    section: 'Group Education',
                    action: 'Submit',
                    description: `Individual Session  for added to Counseling by user ${this.form.get('childName')?.value} ,${this.form.get('childCode')?.value}`,
                    currentIp: localStorage.getItem('currentip')!
                }
                this.mLogService.addLog(activity)
                this.dialogRef.close()
            })
     //add a counselling trigger here for next 10th day


        } else {
            this._snackBar.open('Please enter the form carefully')._dismissAfter(3000)
            this.disableSubmit = false
        }
    }

    Cancel() {
        this.dialogRef.close()
    }

    onBlur(formControl: any) {
        // if (formControl.value !== null) {
        //     formControl.setValue(capitalizeSentence(formControl.value.toString())
        //     )
        // }
    }

    orderChildrenData() {
        this.childrenData.sort((a, b) => {
            const firstNameA = a.firstName.toLowerCase();
            const firstNameB = b.firstName.toLowerCase();
            if (firstNameA < firstNameB) {
                return -1;
            }
            if (firstNameA > firstNameB) {
                return 1;
            }
            return 0;
        });
    }
    buildTask(childName: string, centreCode: string) {
        const taskDate =new Date()
        const { assignees } = this.mTaskService.getTaskForAndCollaboratorsEducationTrigger(centreCode, 'Individual Counselling Session');
        taskDate.setDate(taskDate.getDate() + 10)
        const mCounsellingTask: Partial<Task> = {
            title: `Conduct Regular Individual  session for ${childName}`,
            done: false,
            priority: 'medium',
            assignees: assignees,
            due_date: taskDate,
            note: `Conduct Regular Individual of child ${childName} of ${this.CentreName.value}`,
        };
        return mCounsellingTask
    }

}


function capitalizeSentence(sentence: string) {
    if (!sentence) return ''; // Handle empty input

    const words = sentence.split(' ');
    const capitalizedWords = words.map(word => {
        if (word.length > 0) {
            return word[0].toUpperCase() + word.slice(1).toLowerCase();
        }
        return word;
    });
    return capitalizedWords.join(' ');

}
